import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService, EntitiesService, CurrenciesService } from '../shared/services';
import { ModalService } from '../shared/modules/modal/modal.service';

import { EntityModalComponent } from '../entity/entity-modal/entity-modal.component';
import { MenuComponent } from '../shared/components/menu/menu-component';

import { Entity, EntityModalPayload } from '../shared/models';
import { AllowedRoles } from 'src/app/shared/models/user-permissions-policy';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent extends MenuComponent implements OnInit {

  userRole: string;
  allowedRoles = AllowedRoles;

  constructor(
    protected router: Router,
    protected sessionService: SessionService,
    protected modalService: ModalService,
    private _currenciesService: CurrenciesService,
    private _entitiesService: EntitiesService,
    private _sessionService: SessionService
  ) {
    super(router, sessionService, modalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this._entitiesService.setActiveTab(0);
    this.userRole = this._sessionService.getUserRole();
  }

  upe(): void {
    const upeId = this.getUpeId();
    if (upeId) {
      this.modalService.openModal({
        component: EntityModalComponent,
        data: {
          upe: true,
          entityId: upeId,
        } as EntityModalPayload,
        success: (result: Entity) => {
          this.setCurrency(result.upeCurrency.currencyId);
          this.sessionService.setContainerUpeId(result.entityId);
          this.sessionService.setContainerUpeCurrencyScale(result.upeCurrencyScale);
        },
      });
    } else {
      this.modalService.openModal({
        component: EntityModalComponent,
        data: {
          upe: true,
        } as EntityModalPayload,
        success: (result: Entity) => {
          this.sessionService.setContainerUpeId(result.entityId);
          this.sessionService.setContainerUpeCurrencyScale(result.upeCurrencyScale);
        },
      });
    }
  }

  wtpr(): void {
    if (this.userRole !== 'repouser') {
      this.goToRouteWithUpeCheck('wtpr/world');
    }
  }

  masterFile(): void {
    if (this.userRole !== 'repouser' && this.userRole !== 'tpsafeuser') {
      this.goToRouteWithUpeCheck('master-file');
    }
  }

  localFiles(): void {
    if (AllowedRoles.includes(this.userRole)) {
      this.router.navigate([`/local-files`]);
    }
  }

  complianceCentral(): void {
    this.router.navigate(['/central/compliance']);
  }

  private setCurrency(currencyId: number): void {
    this._currenciesService.show(currencyId).subscribe(({ data }) => {
      const currency = data;
      this.sessionService.setContainerUpeCurrency(currency);
    });
  }
}
